import React, { useState, useEffect, useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import classes from './Layout.module.css';
import Toolbar from '../components/Navigation/Toolbar/Toolbar';
import SideDrawer from '../components/Navigation/SideDrawer/SideDrawer';
import { PATHNAMES } from '../App';
import { mixerPathForHost } from '../mixer-routing';

export const WebsiteContext = React.createContext({ siteName: "Setup's Projects" });

function Layout() {
  const location = useLocation();
  const [showSideDrawer, setShowSideDrawer] = useState(false);
  const [siteName, setSiteName] = useState("Setup's Projects");
  const path = ['/', '/index.html'].includes(location.pathname) ? mixerPathForHost(window.location.hostname) || '/' : location.pathname.replace(/\/$/, '');
  const isMixer = [PATHNAMES.PIXELMIXER, PATHNAMES.CUTEMIXER].includes(path);

  useEffect(() => {
    let name;
    switch (path) {
      case PATHNAMES.HOME:
        name = "Setup's Projects";
        break;
      case PATHNAMES.FINANCING:
        name = 'Financing';
        break;
      case PATHNAMES.PIXELMIXER:
        name = 'Overwatch Pixel Mixer';
        break;
      case PATHNAMES.CUTEMIXER:
        name = 'Overwatch Cute Mixer';
        break;
      case PATHNAMES.PHARMERCYBIRD:
        name = 'Pharmercybird';
        break;
      default:
        name = "Setup's Projects";
        break;
    }
    setSiteName(name);
  }, [path]);

  const sideDrawerClosedHandler = useCallback(() => {
    setShowSideDrawer(false);
  }, []);

  const sideDrawerToggleHandler = useCallback(() => {
    setShowSideDrawer((prev) => !prev);
  }, []);

  return (
    <WebsiteContext.Provider value={{ siteName }}>
      <div className={classes.container}>
        {!isMixer && <Toolbar drawerToggleClicked={sideDrawerToggleHandler} />}
        {!isMixer && <SideDrawer open={showSideDrawer} closed={sideDrawerClosedHandler} />}
        <main className={`${classes.Content} ${isMixer ? classes.MixerContent : ''}`}>
          <Outlet />
        </main>
      </div>
    </WebsiteContext.Provider>
  );
}

export default Layout;
